module.exports = __webpack_public_path__ + "static/media/link.4e1354fe.svg";